"use client";

import React from "react";
import { Badge as BadgeIcon } from "lucide-react";
import "./LITApprovedBadge.css";

type Props = {
  size?: "sm" | "md";
  /** Optional override. If not provided, a clear default title is used. */
  title?: string;
  className?: string;
};

// Centralized default messaging (generic across sections/items)
const DEFAULT_APPROVED_TITLE =
  "TownLIT Approval — This badge indicates that this item/section has been reviewed and approved by TownLIT. The member has provided the required documentation or equivalent evidence and passed verification.";

const LITApprovedBadge: React.FC<Props> = ({
  size = "sm",
  title, // let it be optional; we'll fall back to DEFAULT_APPROVED_TITLE
  className = "",
}) => {
  // Resolve title/aria text once
  const resolvedTitle = title ?? DEFAULT_APPROVED_TITLE;

  return (
    <div
      className={`lit-approved-badge lit-approved-badge--${size} ${className}`}
      title={resolvedTitle}
      aria-label={resolvedTitle} // accessible name mirrors the tooltip text
      role="img"
    >
      <BadgeIcon className="lit-approved-badge__icon" strokeWidth={1} aria-hidden />
      <span className="lit-approved-badge__mono" aria-hidden>
        LIT
      </span>
    </div>
  );
};

export default LITApprovedBadge;
